<template>
  <div
    class="relative flex items-start max-md:flex-col-reverse sm:gap-35 md:sticky md:top-[100px]"
  >
    <div
      class="pdp-gallery__thumbs-wrap max-md:w-full max-md:px-30 relative md:flex-[0_0_84px]"
    >
      <div
        ref="thumbsRef"
        class="pdp-gallery__thumbs flex gap-10 max-sm:mt-0 md:flex-col md:max-h-[543px] md:overflow-y-auto max-md:overflow-x-auto max-md:max-w-[182px] max-md:mx-auto"
      >
        <img
          v-for="(image, index) in imagesArr"
          :key="index"
          :src="image.src"
          alt="thumbnail"
          class="block aspect-square cursor-pointer object-cover transition-all duration-300 md:w-full max-md:w-[38px] max-md:h-[38px] max-md:flex-shrink-0 opacity-90 bg-[#F4F4F4]"
          :class="{'!opacity-1': index === activeIndex}"
          @click="onImage(index)"
        />
      </div>
      <button
        type="button"
        class="pdp-gallery__thumbs-arrow pdp-gallery__thumbs-arrow--prev"
        aria-label="Previous thumbnails"
        @click="scrollThumbs(-1)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="18" viewBox="0 0 7 18" fill="none">
          <g clip-path="url(#clip0_pdp_thumbs_prev)">
            <path d="M5.81323 13.3427L1.06674 8.16869L5.81323 2.99469" stroke="#0057C2" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_pdp_thumbs_prev">
              <rect width="6.87994" height="18" fill="white" transform="translate(6.87994 18) rotate(-180)" />
            </clipPath>
          </defs>
        </svg>
      </button>
      <button
        type="button"
        class="pdp-gallery__thumbs-arrow pdp-gallery__thumbs-arrow--next"
        aria-label="Next thumbnails"
        @click="scrollThumbs(1)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="18" viewBox="0 0 7 18" fill="none">
          <g clip-path="url(#clip0_pdp_thumbs_next)">
            <path d="M1.18677 13.3427L5.93326 8.16869L1.18677 2.99469" stroke="#0057C2" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_pdp_thumbs_next">
              <rect width="6.87994" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
    </div>

    <div class="relative flex-1 pb-[48px] max-sm:pb-10">
      <Fancybox
        ref="fcRef"
        :options="{
          Dots: true,
          Carousel: {infinite: true},
          Thumbs: false,
        }"
        :imgs="imagesArr"
        :key="selectedIndex"
      >
        <div
          class="f-carousel__slide"
          :data-thumb-src="image?.src"
          v-for="(image, index) in imagesArr"
          :key="index"
        >
          <img
            :src="image?.src"
            :alt="image?.alt"
            data-fancybox="gallery"
            class="h-full w-full object-cover"
            v-if="visibleImage"
          />
        </div>
      </Fancybox>

      <button
        type="button"
        class="pdp-gallery__arrow pdp-gallery__arrow--prev"
        aria-label="Previous image"
        @click="goPrev"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none">
          <g clip-path="url(#clip0_pdp_prev)">
            <path d="M10.0481 18.8728L1.84382 9.99999L10.0481 1.12718" stroke="#0057C2" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_pdp_prev">
              <rect width="11.8919" height="20" fill="white" transform="translate(11.8919 20) rotate(-180)" />
            </clipPath>
          </defs>
        </svg>
      </button>
      <button
        type="button"
        class="pdp-gallery__arrow pdp-gallery__arrow--next"
        aria-label="Next image"
        @click="goNext"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none">
          <g clip-path="url(#clip0_pdp_next)">
            <path d="M1.84382 1.12718L10.0481 10L1.84382 18.8728" stroke="#0057C2" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_pdp_next">
              <rect width="11.8919" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Fancybox from "../Fancybox/index.vue";

export default {
  name: "PdpGallery",
  components: {Fancybox},
  props: {
    images: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      data: JSON.parse(this.images),
      visibleImage: false,
      activeIndex: 0,
    };
  },
  computed: {
    ...mapState("product", ["selectedIndex"]),
    imagesArr() {
      return this.data?.singleVariant
        ? this.data?.images
        : this.data?.images[this.selectedIndex] ?? [];
    },
  },
  methods: {
    onImage(index) {
      this.activeIndex = index;
      const dots = document.querySelectorAll(".f-carousel__dots li button");
      if (dots[index]) dots[index].click();
    },
    goPrev() {
      const inst = this.$refs.fcRef?.fcInstance;
      if (inst && typeof inst.slidePrev === "function") inst.slidePrev();
    },
    goNext() {
      const inst = this.$refs.fcRef?.fcInstance;
      if (inst && typeof inst.slideNext === "function") inst.slideNext();
    },
    scrollThumbs(direction) {
      const el = this.$refs.thumbsRef;
      if (!el) return;
      el.scrollBy({left: direction * 100, behavior: "smooth"});
    },
    fixImages() {
      setTimeout(() => {
        const placeholder = document.getElementById("pdp-lcp-placeholder");
        if (placeholder) placeholder.remove();
        this.visibleImage = true;
      }, 100);
    },
  },
  watch: {
    selectedIndex() {
      this.visibleImage = false;
      this.activeIndex = 0;
      this.fixImages();
    },
  },
  mounted() {
    this.fixImages();
  },
};
</script>

<style>
.pdp-gallery__thumbs {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.pdp-gallery__thumbs::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}
:root {
  --f-carousel-dot-width: 15px !important;
  --f-carousel-dot-height: 15px !important;
  --f-carousel-dots-height: 10px !important;
  --f-carousel-dot-opacity: 1;
  --f-carousel-dot-color: #c5eaff;
}
.f-carousel__dots {
  bottom: -32px;
  left: 50%;
  transform: translateX(-50%);
  @apply max-sm:hidden;
}
.f-carousel.has-dots {
  @apply max-sm:!mb-0;
}
.f-carousel__dot {
  border: 1px solid #0057c2;
  background: transparent;
}
.is-current .f-carousel__dot {
  @apply !border-blue !bg-blue;
}
.f-carousel__nav {
  display: none !important;
}
.pdp-gallery__arrow {
  position: absolute;
  bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 2;
}
.pdp-gallery__arrow--prev {
  left: 0;
}
.pdp-gallery__arrow--next {
  right: 0;
}
.pdp-gallery__arrow:hover svg path {
  opacity: 0.7;
}
@media (max-width: 640px) {
  .pdp-gallery__arrow {
    display: none;
  }
}
.pdp-gallery__thumbs-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: none;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 2;
}
.pdp-gallery__thumbs-arrow--prev {
  left: 40px;
}
.pdp-gallery__thumbs-arrow--next {
  right: 40px;
}
.pdp-gallery__thumbs-arrow:hover svg path {
  opacity: 0.7;
}
@media (max-width: 767px) {
  .pdp-gallery__thumbs-arrow {
    display: flex;
  }
}
.fancybox__content {
  max-width: 90vw;
  max-height: 90vh;
}
.f-thumbs__slide__button::after {
  display: none;
}
</style>
